import { useQuery } from '@apollo/client/react'
import { ScormModuleStatus } from '@zeus/index'
import { GQL_CERTIFICATE_TEMPLATE_OPTIONS } from '~/gql/certificates/certificates'
import { GQL_GROUPS } from '~/gql/groups/groups'
import { GQL_SCORM_MODULES } from '~/gql/scorm-modules/scorm-modules'
import { GQL_USERS_WITH_FILTERS } from '~/gql/users/users'

/**
 * Ce que le formulaire d'un parcours propose : modules prêts, comptes,
 * groupes et modèles d'attestation (#162). Rien n'est lu quand le formulaire ne peut pas s'ouvrir (#11) — ces
 * lectures exigent des capacités qu'un formateur sans droit de gestion peut ne
 * pas avoir, et finiraient en erreur.
 */
export function useSessionFormOptions(enabled: boolean) {
  const { data: modulesData } = useQuery(GQL_SCORM_MODULES, { skip: !enabled })
  const { data: usersData } = useQuery(GQL_USERS_WITH_FILTERS, {
    variables: { input: { skip: 0, take: 1000, searchInput: '' } },
    skip: !enabled,
  })
  const { data: groupsData } = useQuery(GQL_GROUPS, { skip: !enabled })
  const { data: templatesData } = useQuery(GQL_CERTIFICATE_TEMPLATE_OPTIONS, { skip: !enabled })

  return {
    readyModules: (modulesData?.scormModules ?? []).filter(m => m.status === ScormModuleStatus.READY),
    users: usersData?.getFilteredUsers?.users ?? [],
    groups: groupsData?.groups ?? [],
    certificateTemplates: templatesData?.certificateTemplateOptions ?? [],
  }
}
